import { createContext, useContext } from "react";

export type ThemeMode = "light" | "dark";

interface ThemeModeContextValue {
  themeMode: ThemeMode;
  toggleThemeMode: () => void;
}

const ThemeModeContext = createContext<ThemeModeContextValue>({
  themeMode: "light",
  toggleThemeMode: () => undefined,
});

export const ThemeModeProvider = ThemeModeContext.Provider;

export const useThemeMode = () => useContext(ThemeModeContext);
